import React from 'react';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useMenu } from '@/context/MenuContext';
import { getMenuIcon } from '@/lib/menuUtils';
import MenuNode from './MenuNode';

/**
 * 모바일 전체 메뉴 서랍.
 * 하단 탭바의 '전체'에서 열리며, 모든 모듈의 메뉴를 한 번에 보여준다.
 */
const MobileMenuDrawer = ({ isOpen, onClose }) => {
  const { modules } = useMenu();

  return (
    <>
      <div
        className={cn(
          'fixed inset-0 z-[90] bg-black/55 transition-opacity lg:hidden',
          isOpen ? 'opacity-100' : 'pointer-events-none opacity-0'
        )}
        onClick={onClose}
        role="presentation"
      />

      <div
        className={cn(
          'fixed inset-x-0 bottom-0 z-[95] flex max-h-[80vh] flex-col rounded-t-lg bg-chrome text-chrome-text transition-transform duration-300 lg:hidden',
          isOpen ? 'translate-y-0' : 'translate-y-full'
        )}
        role="dialog"
        aria-modal="true"
        aria-label="전체 메뉴"
      >
        <div className="flex shrink-0 items-center justify-between border-b border-chrome-border px-4 py-3">
          <h2 className="text-sm font-bold">전체 메뉴</h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded p-1 text-chrome-muted hover:bg-chrome-hover hover:text-chrome-strong"
            aria-label="닫기"
          >
            <X size={20} />
          </button>
        </div>

        <div className="scrollbar-hide flex-1 overflow-y-auto px-3 pb-6 pt-3">
          {modules
            .filter((module) => module.isMobileVisible)
            .map((module) => {
              const children = (module.children || []).filter((child) => child.isDisplay);

              return (
                <section key={module.menuId} className="mb-4">
                  <p className="mb-1 flex items-center gap-1.5 px-3 text-[11px] font-bold uppercase tracking-wider text-chrome-muted">
                    {getMenuIcon(module.iconClass, 12)}
                    {module.menuName}
                  </p>

                  {/* 모듈 헤더에 이미 아이콘이 있으므로 하위는 depth 1 로 렌더해 중복을 피한다 */}
                  {children.length > 0 ? (
                    children.map((child) => (
                      <MenuNode key={child.menuId} node={child} depth={1} isMobile onNavigate={onClose} />
                    ))
                  ) : (
                    <MenuNode node={module} depth={1} isMobile onNavigate={onClose} />
                  )}
                </section>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default MobileMenuDrawer;
